import { z } from 'zod';
import { requireAtLeastOneField } from '../zod-helpers/index.js';
import { promotionAccountPctSchema } from './promotion-account-pct-schema.js';
import { promotionBrandPctSchema } from './promotion-brand-pct-schema.js';
import { promotionCategoryIdsSchema } from './promotion-category-ids-schema.js';
import { promotionNameSchema } from './promotion-name-schema.js';
import { promotionTypeSchema } from './promotion-type-schema.js';
// The brand is locked after create, and the type-conditional rules run in the resolver on the merged row.
export const updatePromotionInputSchema = requireAtLeastOneField(z.object({
    name: promotionNameSchema.optional(),
    type: promotionTypeSchema.optional(),
    brandPct: promotionBrandPctSchema,
    accountPct: promotionAccountPctSchema,
    categoryIds: promotionCategoryIdsSchema,
    requiresApproval: z.boolean().optional(),
}));
//# sourceMappingURL=update-input.js.map